function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8.18571L12 12.9079M12 12.9079L3.49997 8.18571M12 12.9079L12 22.408M21 16.9665V8.8494C21 8.50676 21 8.33544 20.9495 8.18264C20.9049 8.04747 20.8318 7.92338 20.7354 7.81869C20.6263 7.70036 20.4766 7.61716 20.177 7.45075L12.777 3.33964C12.4934 3.18208 12.3516 3.1033 12.2015 3.07242C12.0685 3.04508 11.9315 3.04508 11.7986 3.07242C11.6484 3.1033 11.5066 3.18208 11.223 3.33964L3.82297 7.45076C3.52345 7.61716 3.37369 7.70036 3.26463 7.8187C3.16816 7.92339 3.09515 8.04747 3.05048 8.18264C3 8.33544 3 8.50676 3 8.84941V16.9665C3 17.3092 3 17.4805 3.05048 17.6333C3.09515 17.7685 3.16816 17.8925 3.26463 17.9972C3.37369 18.1156 3.52345 18.1988 3.82297 18.3652L11.223 22.4763C11.5066 22.6338 11.6484 22.7126 11.7986 22.7435C11.9315 22.7708 12.0685 22.7708 12.2015 22.7435C12.3516 22.7126 12.4934 22.6338 12.777 22.4763L20.177 18.3652C20.4766 18.1988 20.6263 18.1156 20.7354 17.9972C20.8318 17.8925 20.9049 17.7685 20.9495 17.6333C21 17.4805 21 17.3092 21 16.9665Z",
    stroke: "#697586",
    style: {
      stroke: "#697586",
      stroke: "color(display-p3 0.4124 0.4574 0.5249)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.6728f19a937a46db0d3ffa65e385175e.svg";
export { ForwardRef as ReactComponent };